import type { TestGroupingItem } from '@vedalib/editor/lib/elements'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import { motion } from 'framer-motion'
import lodash from 'lodash'
import { useContext } from 'use-context-selector'

import { getObjectFitDivMap } from 'components/Editor/EditorElements/utils/getObjectFitDivMap'
import { RichTextViewer } from 'components/form/RichText/RichTextViewer'
import { useUrlByUsage } from 'utils/files'

import TestGroupingContext from '../../TestGroupingContext'
import { borderRadiusContent } from '../../helper'
import * as s from './MobileScaledAnswer.module.scss'

interface IMobileScaledAnswerProps {
  item: TestGroupingItem
}

const MobileScaledAnswer = ({ item }: IMobileScaledAnswerProps) => {
  const { styles, font } = useContext(TestGroupingContext)
  const url = useUrlByUsage(item.image, FileUsageTypeEnum.image)

  const borderRadius = borderRadiusContent(styles.answer) || styles.common.borderRadius

  return (
    <motion.div
      animate={{
        scale: 0.3,
        opacity: 0,
        y: -20,
      }}
      className={s.scaledAnswer}
      exit={{
        scale: 0,
        opacity: 0,
      }}
      initial={{
        scale: 1,
        opacity: 1,
        y: 0,
      }}
      style={{
        ...lodash.omit(styles.answer, ['borderColor', 'borderWidth', 'borderStyle']),
        ...styles.common,
        backgroundImage: url && `url(${url})`,
        backgroundSize: getObjectFitDivMap(item.image?.objectFit),
      }}
      transition={{
        type: 'spring',
        stiffness: 120,
        damping: 20,
        mass: 0.8,
      }}
    >
      <div
        className={s.itemMask}
        style={{
          backgroundColor: item.overlay || '',
          borderRadius,
        }}
      />
      <div className={s.itemLabel} style={{ justifyContent: styles.answer.alignItems }}>
        <div className={s.textInner} style={font?.base}>
          <RichTextViewer styles={font} value={item.label} />
        </div>
      </div>
    </motion.div>
  )
}

export default MobileScaledAnswer
